import React from 'react'
import './Authenticate.css'
import SideNav from '../layout/SideNav'
import Card from '../core/Card'
import LoginPage from './LoginPage'
import Logo from '../core/components/Logo'
import { Switch, DatePicker, Select, Modal, Input, Icon as AIcon, Tooltip, Form, Alert, Popconfirm, Row} from 'antd';
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon, ForwardIcon } from '../core/icons'
import { Field, reduxForm, submit } from 'redux-form'
import makeField from '../account/makeField'
import {connect} from 'react-redux';
import { checkEmail } from './actions'
import {
  Button,
} from './steps/index'
const AInput = makeField(Input)

const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined

const required = value => (value ? undefined : 'Required')

// Field size override
const layout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  }
}

const Start = ({submitting, handleSubmit, group_image_url, group_company_name, ...props}) =>
  <div className="Authenticate">
    <Card>
    <form onSubmit={handleSubmit}>
      <Row justify="center" type="flex">
        {group_image_url&&<img style={{maxHeight:'50px'}} src={group_image_url}/> || <Logo/>}
      </Row>

      {group_company_name&&
        <Row justify="center" type="flex">
          <h3>{group_company_name}</h3>
        </Row>
      }

      <Row justify="center" type="flex">
        <h3>What's your email?</h3>
      </Row>

      <Field
        layout={layout}
        placeholder="email@email.com"
        name="email"
        type="email"
        autoFocus
        component={AInput}
        validate={[email, required]}
      />


      <Button htmlType="submit" fullWidth primary loading={submitting}>Sign up / Login</Button>
    </form>
    </Card>
  </div>



const mapStateToProps = (state, ownProps) => {
  // ?gt=3234d02c8ec24ab5996bbb63a183c06e
  // &group_company_name=Instacart
  // &group_image_url=https://everlance.s3.amazonaws.com/uploads/photo/2017-12-01-2d07d14c9f6e4fd3a0b5899fac181bfc/logo-green.png
  return {
    initialValues: {
      email: state.user.email
    },
    group_image_url: state.user.group_image_url,
    group_company_name: state.user.group_company_name
  }
}

export default connect( mapStateToProps )(
  reduxForm({
    form: 'start',
    onSubmit: (values, dispatch)=> dispatch(checkEmail(values)),
  })(Start)
)



// WEBPACK FOOTER //
// ./src/user/Start.js